import { render, staticRenderFns } from "./postView.vue?vue&type=template&id=fe40a62a&scoped=true"
import script from "./postView.vue?vue&type=script&lang=js"
export * from "./postView.vue?vue&type=script&lang=js"
import style0 from "./postView.vue?vue&type=style&index=0&id=fe40a62a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe40a62a",
  null
  
)

export default component.exports